var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2ProgramInstallation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 43h10V6h4v37h10L38 55.91 26 43zm22-23v4h11v38H17V24h12v-4H13v46h50V20H48z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Program_installation.05f395b1.svg";
export { SvgJ2ProgramInstallation as ReactComponent };